import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pago-recibido',
  templateUrl: './pago-recibido.component.html',
  styleUrls: ['./pago-recibido.component.scss']
})
export class PagoRecibidoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
